// Footer.jsx 🔧
import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="text-light py-3 mt-4"
      style={{ backgroundColor: "rgb(30, 30, 30)", "--bs-bg-opacity": 1 }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <p className="mb-0" style={{ color: "#b77945" }}>
              © {currentYear} CIRCET CTI. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
